// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3HzFc","header":"PatientBlock_header__1dqtH","label":"PatientBlock_label__1veTs","option":"PatientBlock_option__2wR0N"};